import Feature14_2 from './Feature14_2'
export default Feature14_2
